import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-resultado',
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.css']
})
export class ResultadoComponent implements OnInit {

  respuesta: string;
  columnas: number = 6;
  colspanImg: number = 3;
  colspanError: number = 3;
  columnaOculta: boolean = false;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.respuesta = this.activatedRoute.snapshot.paramMap.get('tipo');
    if (window.innerWidth <= 720) {
      this.columnas = 1;
      this.colspanImg = 1;
      this.colspanError = 1;
      this.columnaOculta = true;
    } else {
      this.columnas = 6;
      this.colspanImg = 3;
      this.colspanError = 3;
      this.columnaOculta = false;
    }
  }

  onResize(event: any) {
    if (event.target.innerWidth <= 720) {
      this.columnas = 1;
      this.colspanImg = 1;
      this.colspanError = 1;
      this.columnaOculta = true;
    } else {
      this.columnas = 6;
      this.colspanImg = 3;
      this.colspanError = 3;
      this.columnaOculta = false;
    }
  }
}
